import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { Layout } from './layout/layout/layout';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login').then((m) => m.LoginComponent),
  },
  {
    path: '',
    component: Layout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard').then((m) => m.DashboardComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/users/users').then((m) => m.UsersComponent),
      },
      {
        path: 'users/:id',
        loadComponent: () =>
          import('./pages/users/user-detail/user-detail').then((m) => m.UserDetailComponent),
      },
      {
        path: 'sql-console',
        loadComponent: () =>
          import('./pages/sql-console/sql-console.component').then((m) => m.SqlConsoleComponent),
      },
      {
        path: 'system',
        children: [
          {
            path: 'feature-flags',
            loadComponent: () =>
              import('./pages/system/feature-flags/feature-flags').then(
                (m) => m.FeatureFlagsComponent
              ),
          },
          {
            path: 'promo-codes',
            loadComponent: () =>
              import('./pages/system/promo-codes/promo-codes').then((m) => m.PromoCodesComponent),
          },
          {
            path: 'groups',
            loadComponent: () =>
              import('./pages/system/groups/groups').then((m) => m.GroupsComponent),
          },
          {
            path: 'groups/:id',
            loadComponent: () =>
              import('./pages/system/groups/group-detail/group-detail').then(
                (m) => m.GroupDetailComponent
              ),
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
